import React from 'react';

export default (props) => (
  <div className='subcomponent'>
    Subcomponent
  </div>
)